var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHandCursor2734 = function SvgHandCursor2734(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 34,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hand_cursor_27_34_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M23.4 12.454v1.779h-1.8v-3.558H18v1.779h-1.8V8.896h-3.6v3.558h-1.8V8.896H7.2v8.895H5.4v-5.337H1.8v7.116h1.8v3.558h1.8v3.558h18V21.35h1.8v-8.895z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M5.4 12.454v5.337H3.6v-5.337zM9 8.896H7.2v8.895H9zm0 17.79h14.4v-1.779H9zm5.4-17.79h-1.8v3.558h1.8zm5.4 1.779H18v1.779h1.8zm3.6 8.895v1.779h1.8v-1.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1.8 12.453H0v1.78h1.8zM3.6 19.57H1.8v1.778h1.8zM3.6 10.675H1.8v1.779h1.8zM5.4 23.128H3.6v1.779h1.8zM23.4 10.675h-1.8v3.558h1.8zM18 8.896h-1.8v3.558H18zM7.2 8.896H5.4v8.895h1.8zM7.2 7.116v1.78h3.6v3.557h1.8V7.116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M5.4 10.674H3.6v1.78h1.8zm-3.6 3.559H0v5.337h1.8zm14.4-5.338V7.116h-3.6v1.78zm5.4 1.78v-1.78H18v1.78zm3.6 1.778v8.896H27v-8.896zm-1.8 14.233h1.8v-5.337h-1.8zm-19.8-1.78v1.78h1.8v-1.78zm0-3.557H1.8v1.779h1.8zm1.8 5.337v1.779h18v-1.779zm18-16.012v1.78h1.8v-1.78zM12.6 23.128h1.8V17.79h-1.8zm3.6 0H18V17.79h-1.8zm3.6 0h1.8V17.79h-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M9 7.117V3.558H7.2V1.78H3.6v3.558h1.8v3.559h1.8v8.895h3.6V7.117z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M7.2 17.791H9V8.896H7.2zm0-12.453H5.4v3.558h1.8zm-3.6-1.78v1.78h1.8v-1.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.6 1.78H1.8v1.778h1.8zM5.4 0H3.6v1.78h1.8zM3.6 7.116h1.8V5.337H3.6zm1.8 10.675h1.8V8.895H5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M9 3.558V1.78H7.2v1.78zm-5.4 0H1.8v1.78h1.8zm0 5.337h1.8V7.116H3.6zM7.2 0H5.4v1.78h1.8zm5.4 7.116V5.337h-1.8V3.558H9v3.558zM3.812 28.465H5.4v3.953H3.812zM23.398 28.465h1.589v3.953h-1.589zM23.398 32.419V34H5.406V32.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.406 28.459H23.4v3.96H5.406z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hand_cursor_27_34_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h27v34H0z"
  })))));
};
export default SvgHandCursor2734;